import SchadenfallModelManager from '../../core/service/SchadenfallModelManager';
import {TSErfassungsArt} from '../../models/enums/TSErfassungsArt';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import TSAbstractEntity from '../../models/TSAbstractEntity';
import TSSchadenfall from '../../models/TSSchadenfall';
import AbstractGesuchViewController from './abstractModelController';
import {TSSchadenfallStatus} from '../../models/enums/TSSchadenfallStatus';
import IScope = angular.IScope;

export default class AbstractModelManagerController<T extends TSAbstractEntity> extends AbstractGesuchViewController<T> {

    schadenfallModelManager: SchadenfallModelManager;
    pageName?: string;

    constructor(schadenfallModelManager: SchadenfallModelManager, $scope: IScope, pageName?: string) {
        super($scope);
        this.schadenfallModelManager = schadenfallModelManager;
        this.pageName = pageName;
    }

    $onInit() {
        super.$onInit();
    }

    public isSchadenFallReadonly(): boolean {
        if (this.pageName) {
            return this.schadenfallModelManager.isSchadenReadonly(this.pageName);
        }
        console.warn('No page name');
        return false
    }

    public isSchadenFallVisible(): boolean {
        if (this.pageName) {
            return this.schadenfallModelManager.isSchadenVisible(this.pageName);
        }
        console.warn('No page name');
        return false
    }

    public isSchadenFallVisibleAndNotNew(): boolean {
        if (this.pageName) {
            return this.schadenfallModelManager.isSchadenVisibleAndNotNew(this.pageName);
        }
        console.warn('No page name');
        return false
    }

    public isPapiergesuch(): boolean | undefined {
        let schadenfall: TSSchadenfall | undefined = this.schadenfallModelManager.getSchadenfall();
        if (schadenfall) {
            return schadenfall.erfassungsart === TSErfassungsArt.PAPIER;
        } else {
            return undefined;
        }
    }

    public isPhoneRequired(): boolean | undefined {
        let schadenfall: TSSchadenfall | undefined = this.schadenfallModelManager.getSchadenfall();
        if (schadenfall) {
            return schadenfall.status === TSSchadenfallStatus.NEU;
        } else {
            return undefined;
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/abstractModelManagerController.ts